(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1230],{

/***/ 29885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ attachWarehouseData; },
/* harmony export */   "Xq": function() { return /* binding */ addToCart; }
/* harmony export */ });
/* unused harmony export updateCart */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45094);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33273);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44753);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88751);
/* harmony import */ var _utils_removeCart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3783);







async function addToCart(items, showPreview, message, callback, taxCalculate) {
    let isSharedCart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, isPreviewCart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    let actions = [];
    let userZipCode;
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCart */ .RV)(res));
    });
    const { cart: { cart: { lineItems =[] , customLineItems =[]  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    let sku = "";
    for (let product of items){
        var ref, ref1;
        const associatedProduct = items.find((item)=>{
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : item.isInstallService) && (item === null || item === void 0 ? void 0 : item.installServiceName) === (product === null || product === void 0 ? void 0 : product.sku) && (item === null || item === void 0 ? void 0 : item.sku) === (product === null || product === void 0 ? void 0 : (ref = product.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedProduct);
        });
        const isInCart = product.isBundle ? customLineItems.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleSku) === product.sku;
        }) : !(product === null || product === void 0 ? void 0 : product.isInstallService) && associatedProduct && (associatedProduct === null || associatedProduct === void 0 ? void 0 : associatedProduct.sku) ? lineItems === null || lineItems === void 0 ? void 0 : lineItems.find((item)=>{
            var ref, ref1, ref2;
            return !item.custom.fields.isBundleChildItem && (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === (product === null || product === void 0 ? void 0 : product.sku) && (item === null || item === void 0 ? void 0 : (ref1 = item.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedProduct) === (associatedProduct === null || associatedProduct === void 0 ? void 0 : associatedProduct.sku);
        }) : lineItems === null || lineItems === void 0 ? void 0 : lineItems.find((item)=>{
            var ref;
            return !item.custom.fields.isBundleChildItem && (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === (product === null || product === void 0 ? void 0 : product.sku);
        });
        const lineItemId = isInCart === null || isInCart === void 0 ? void 0 : isInCart.id;
        let warehouses = [
            JSON.stringify(product === null || product === void 0 ? void 0 : product.warehouses)
        ];
        const warehouse = isPreviewCart ? product === null || product === void 0 ? void 0 : product.warehouses : isSharedCart ? (ref = product.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.warehouses : warehouses;
        let customObj = {
            type: {
                key: "cartLineItemAdditionalInfo",
                typeId: "type"
            }
        };
        if (product.isInstallService && warehouse) {
            sku = product === null || product === void 0 ? void 0 : product.sku;
            customObj = {
                ...customObj,
                fields: {
                    warehouses: warehouse,
                    associatedService: product === null || product === void 0 ? void 0 : product.installServiceName,
                    associatedServiceQty: product === null || product === void 0 ? void 0 : product.installServiceQty,
                    section: product === null || product === void 0 ? void 0 : product.section
                }
            };
        } else {
            if (associatedProduct && (associatedProduct === null || associatedProduct === void 0 ? void 0 : associatedProduct.sku)) {
                customObj = {
                    type: {
                        key: "cartLineItemAdditionalInfo",
                        typeId: "type"
                    },
                    fields: {
                        associatedProduct: associatedProduct.sku,
                        section: product === null || product === void 0 ? void 0 : product.section
                    }
                };
            } else {
                customObj = {
                    ...customObj,
                    fields: {
                        warehouses: warehouse,
                        section: product === null || product === void 0 ? void 0 : product.section
                    }
                };
            }
        }
        if (!isPreviewCart && isInCart) {
            if (product.isBundle) {
                let pincode = await (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getPincode */ .pf)();
                const handleStockError = ()=>{
                    const noStockError = new Event("set-stock-alert");
                    document.dispatchEvent(noStockError);
                };
                const warehouses1 = await (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getETA */ .c5)(product.sku, null, (isInCart === null || isInCart === void 0 ? void 0 : isInCart.quantity) + (product === null || product === void 0 ? void 0 : product.quantity), pincode, false, true, handleStockError);
                if (warehouses1) {
                    const payload = (0,_utils_removeCart__WEBPACK_IMPORTED_MODULE_6__/* .changeBundleQty */ .Wj)(lineItemId, product.sku, (isInCart === null || isInCart === void 0 ? void 0 : isInCart.quantity) + (product === null || product === void 0 ? void 0 : product.quantity), warehouses1, product === null || product === void 0 ? void 0 : product.isInstallService, true);
                    actions = payload;
                    if (product.isInstallService) {
                        const installService = lineItems.find((item)=>{
                            var ref, ref1;
                            if (((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.parentBundleSku) === product.sku) {
                                var ref2, ref3;
                                const category = (ref2 = item.variant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.find((attr)=>attr.name === "ProductLocalCategory");
                                return (category === null || category === void 0 ? void 0 : category.value) === "Install Services";
                            }
                        });
                        if (installService) {
                            actions.push({
                                action: "changeBundleSKUQuantity",
                                lineItemId: installService.id,
                                quantity: installService.quantity + (product === null || product === void 0 ? void 0 : product.quantity)
                            });
                        } else {
                            var ref2, ref3, ref4;
                            const installServiceSku = (ref2 = product.warehouses) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.bundle) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.installationService) === null || ref4 === void 0 ? void 0 : ref4.name;
                            if (installServiceSku) {
                                actions.push({
                                    action: "addBundleSKUQuantity",
                                    customLineItemId: lineItemId,
                                    installServiceSku: installServiceSku,
                                    quantity: product === null || product === void 0 ? void 0 : product.quantity
                                });
                            }
                        }
                    }
                }
            } else {
                actions.push({
                    action: "changeLineItemQuantity",
                    lineItemId: lineItemId,
                    quantity: (isInCart === null || isInCart === void 0 ? void 0 : isInCart.quantity) + (product === null || product === void 0 ? void 0 : product.quantity)
                });
            }
            if ((product === null || product === void 0 ? void 0 : product.isInstallService) && !product.isBundle) {
                var ref5, ref6, ref7, ref8, ref9, ref10;
                const installService1 = lineItems === null || lineItems === void 0 ? void 0 : lineItems.find((item)=>{
                    var ref, ref1, ref2;
                    return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.isBundleChildItem) && (item === null || item === void 0 ? void 0 : (ref2 = item.variant) === null || ref2 === void 0 ? void 0 : ref2.sku) === (product === null || product === void 0 ? void 0 : product.sku);
                });
                const productLineItemId = installService1 === null || installService1 === void 0 ? void 0 : installService1.id;
                actions.push({
                    action: "setLineItemCustomType",
                    lineItemId: productLineItemId,
                    type: {
                        key: "cartLineItemAdditionalInfo",
                        typeId: "type"
                    },
                    fields: {
                        associatedService: (installService1 === null || installService1 === void 0 ? void 0 : (ref5 = installService1.custom) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.associatedService) || (product === null || product === void 0 ? void 0 : product.installServiceName),
                        associatedServiceQty: (installService1 === null || installService1 === void 0 ? void 0 : (ref7 = installService1.custom) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.associatedServiceQty) + (product === null || product === void 0 ? void 0 : product.quantity) || (product === null || product === void 0 ? void 0 : product.installServiceQty),
                        warehouses: (installService1 === null || installService1 === void 0 ? void 0 : (ref9 = installService1.custom) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.warehouses) || warehouse,
                        section: product === null || product === void 0 ? void 0 : product.section
                    }
                });
            }
        } else {
            let bundleCustomObj = null;
            if (isSharedCart) {
                if (product.isBundle) {
                    let pincode1 = await (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getPincode */ .pf)();
                    const warehouses2 = await (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_4__/* .getETA */ .c5)(product.sku, null, product === null || product === void 0 ? void 0 : product.quantity, pincode1, false, true);
                    const payload1 = (0,_utils_removeCart__WEBPACK_IMPORTED_MODULE_6__/* .changeBundleQty */ .Wj)(lineItemId, product.sku, (isInCart === null || isInCart === void 0 ? void 0 : isInCart.quantity) + (product === null || product === void 0 ? void 0 : product.quantity), warehouses2, product === null || product === void 0 ? void 0 : product.isInstallService, true);
                    bundleCustomObj = payload1[0].custom;
                }
            }
            const payload2 = {
                action: product.isBundle ? "addBundleItem" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: bundleCustomObj !== null && bundleCustomObj !== void 0 ? bundleCustomObj : customObj
            };
            if ((product === null || product === void 0 ? void 0 : product.isBundle) && (product === null || product === void 0 ? void 0 : product.isInstallService)) {
                payload2.includeInstallationService = true;
            }
            actions.push(payload2);
        }
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    }
    const { cart: { cart: { version =0 , shippingAddress: { postalCode =""  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    if (isPreviewCart) {
        return actions;
    } else {
        if (actions === null || actions === void 0 ? void 0 : actions.length) {
            updateCart(version, actions, taxCalculate, postalCode, message, callback, userZipCode, isSharedCart, showPreview);
        }
    }
}
async function updateCart(version) {
    let actions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], taxCalculate = arguments.length > 2 ? arguments[2] : void 0, postalCode = arguments.length > 3 ? arguments[3] : void 0, message = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", callback = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{}, userZipCode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", isSharedCart = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false, showPreview = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
    const { isAuth  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const { cart: { cart: { id =""  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const body = {
        version: version,
        actions: actions
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    let atcStatus;
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("/cart/items?cartId=".concat(id, "&expand=calculation"), body);
        const { status , data  } = response;
        if (status === 200) {
            if (!isSharedCart) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCart */ .RV)(data));
            }
            const lineItems = data.lineItems || [];
            const customLineItems = data.customLineItems || [];
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCartCount */ .oJ)((0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getQuantityCount */ .PW)([
                ...lineItems,
                ...customLineItems
            ])));
            if (message) _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .showToast */ .CF)(message));
            if (callback) callback({
                status,
                message: "success",
                data
            });
            if (showPreview) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .showPreviewCart */ .z0)());
            }
            if (!isAuth && data.anonymousId) localStorage.setItem("anonymousId", data.anonymousId);
        } else {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .showToast */ .CF)(i18n.t("kf.cart.label.addToCartErrorMsg")));
        }
    } catch (err) {
        const { response: { status: status1  } = {} , message: message1  } = err;
        if (callback) callback({
            status: status1,
            message: message1
        });
        atcStatus = {
            status: status1,
            message: message1
        };
    }
    return atcStatus;
}
const attachWarehouseData = (items, parentItem)=>{
    if (!window.etaCache) {
        console.warn("Error: ETA cache not available");
        return items;
    }
    return items.map((item)=>{
        try {
            if (item.sku && window.etaCache[item.sku]) {
                var ref;
                const warehouseData = (ref = window.etaCache[item.sku]) === null || ref === void 0 ? void 0 : ref.warehouse;
                if (warehouseData) {
                    return {
                        ...item,
                        warehouses: warehouseData
                    };
                }
            }
        } catch (ex) {
            console.error("Error in getting warehouse for SKU ".concat(item.sku));
        }
        return item;
    }).map((item)=>{
        item.quantity = parentItem.quantity;
        return item;
    });
};


/***/ }),

/***/ 71025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const DisplayDiscountPrice = (param)=>{
    let { discountedPrice =0 , price =0 , currencySign ="$"  } = param;
    if (discountedPrice && discountedPrice !== price) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                    children: "".concat(currencySign, " ").concat(price)
                }),
                " ".concat(currencySign, " ").concat(discountedPrice)
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: "".concat(currencySign, " ").concat(price)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayDiscountPrice);


/***/ }),

/***/ 13926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "L9": function() { return /* binding */ WAIT_TIME_FOR_LEAR_MORE; },
/* harmony export */   "_m": function() { return /* binding */ FREE_MSG; },
/* harmony export */   "iW": function() { return /* binding */ COMPLIMENTARY; },
/* harmony export */   "mh": function() { return /* binding */ ADD_SERVICE; }
/* harmony export */ });
/* unused harmony exports BATHROOM_SERVICES, NAVIGATION, TOILET_INSTALL, INSTALLATION_SERVICES, INSTALL_SERVCIE */
const BATHROOM_SERVICES = "bathroom design services";
const FREE_MSG = "free kohler bathroom design plan consultation";
const NAVIGATION = "navigation";
const WAIT_TIME_FOR_LEAR_MORE = 5000;
const ADD_SERVICE = "add an install service";
const TOILET_INSTALL = "toilet install service";
const INSTALLATION_SERVICES = "installation services";
const INSTALL_SERVCIE = "install service";
const COMPLIMENTARY = "complimentary plan consultation";
const ADD_TO_CART = "add to cart";


/***/ }),

/***/ 59192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ addAnalyticsForClosingRecommendedModal; },
/* harmony export */   "J_": function() { return /* binding */ addAnalyticsForADDtoCart; },
/* harmony export */   "Sr": function() { return /* binding */ addAnalyticsForFreeServices; },
/* harmony export */   "X1": function() { return /* binding */ addAnalyticsForArrows; },
/* harmony export */   "bP": function() { return /* binding */ addAnalyticsForIncludeforRequiredItem; },
/* harmony export */   "fv": function() { return /* binding */ addAnalyticsForAddingRecommendedToCart; },
/* harmony export */   "n8": function() { return /* binding */ addAnalyticsForNavigateToCart; },
/* harmony export */   "sj": function() { return /* binding */ addAnalyticsForToolTip; }
/* harmony export */ });
/* unused harmony export addAnalyticsForheader */
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13926);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34326);



const getProductInfoForAnalytics = function() {
    let cartProductData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { site: { siteName ="n/a"  } = {}  } = page;
    const brand = siteName.toLowerCase();
    const { desc ="" , discountedPrice ="" , price ="" , globalOffer ="n/a" , globalDiscount =0 , name: productTileName = "" , category ="" , discountPriceState ="regular price " , unitPrice ="n/a" , color: productColor = "n/a" , productCoupondiscount =0 , productCouponCode ="n/a" , customerFacingSKU ="n/a" , productPrice =0 , quantity =0 , image ="n/a"  } = cartProductData;
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - 0).toFixed(2)) : 0,
        globalOffer: globalOffer,
        globalDiscount: Number(globalDiscount.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice),
        productCategory: category,
        productColor,
        productCoupondiscount,
        productCouponCode,
        productID: customerFacingSKU,
        productName: productTileName || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName,
        quantity,
        defaultImageName: image,
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category,
        productBrand: brand,
        itemType: "service" || 0
    };
    return productInfo;
};
const addAnalyticsForToolTip = (servicename, title, url, cartProductData)=>{
    const services = servicename.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const statusEvent = title == "add to cart" ? _constants_index__WEBPACK_IMPORTED_MODULE_0__.SUCCESS : "n/a";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products:".concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_SERVICE */ .mh, ":").concat(title),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_SERVICE */ .mh, ":").concat(title),
        eventStatus: statusEvent,
        eventType: "teaser",
        internalLinkName: title,
        internalLinkPosition: "".concat(pageload, ":teaser"),
        internalLinkType: "".concat(pageload, ":").concat(services),
        internalLinkURL: url ? url : "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_SERVICE */ .mh)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, cartProductData);
};
const addAnalyticsForheader = (zipcode, title, isServiceAvailable)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const titleName = title.toLowerCase();
    const internalLink = isServiceAvailable ? ADD_SERVICE : COMPLIMENTARY;
    if (titleName === "change zip code") {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "upsell products:".concat(FREE_MSG, ":").concat(titleName),
            eventMsg: "n/a",
            eventName: "".concat(pageload, ":").concat(FREE_MSG, ":").concat(titleName),
            eventStatus: "n/a",
            eventType: NAVIGATION,
            internalLinkName: titleName,
            internalLinkPosition: "".concat(pageload, ":").concat(NAVIGATION),
            internalLinkType: "".concat(pageload, ":").concat(zipcode),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageload, ":").concat(internalLink)
        };
        pushAnalyticsObjToDataLayer(eventInfo);
    } else {
        const eventInfo1 = {
            clickInternalLinks: "true",
            eventAction: "upsell products :".concat(INSTALLATION_SERVICES, ":").concat(INSTALL_SERVCIE, ":check availability"),
            eventMsg: "n/a",
            eventName: "".concat(pageload, ":").concat(INSTALL_SERVCIE, ":check availability"),
            eventStatus: SUCCESS,
            eventType: NAVIGATION,
            internalLinkName: "search",
            internalLinkPosition: "".concat(pageload, ":find ").concat(INSTALLATION_SERVICES),
            internalLinkType: "".concat(pageload, ":").concat(zipcode),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageload, ":").concat(TOILET_INSTALL)
        };
        pushAnalyticsObjToDataLayer(eventInfo1);
    }
};
const addAnalyticsForFreeServices = (title, url)=>{
    const titleInfo = title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products:".concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .FREE_MSG */ ._m, ": ").concat(titleInfo),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .FREE_MSG */ ._m, ":").concat(titleInfo, " "),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: titleInfo,
        internalLinkPosition: "".concat(pageload, ":teaser"),
        internalLinkType: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .COMPLIMENTARY */ .iW),
        internalLinkURL: url ? url : "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .COMPLIMENTARY */ .iW)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getrequiredProductInfo = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, childindex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, persona = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", qty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, isParent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var ref, ref1, ref2, ref3, ref4;
    const { ProductDescriptionProductShort_s: decs = "" , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = "0" , CustomerFacingBrand_s: brandName = "" , Product_Category: productCategory = "" , RegionBrandName_s: Name = "" , availableQuantity =0 , sku_s: skuid = "" , discountPriceState ="regular price " , productCoupondiscount =0 , productCouponCode ="n/a" , ["productImages.url_ss"]: productImage = [] , ["priceList.".concat(persona, ".finalPrice_d")]: baseprice = 0 , masterSKU_s: mastersku = "" , unitPrice: unitPrice = "" , productParentImage: productParentImage = "" , productColor: productColor = "default" , parentglobalPromotionPrice ="" , itemType ="" , productRoomType ="" , productPrice =""  } = productinfo;
    const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
    const isPdp = (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp";
    var ref5;
    const skuProductId = (ref5 = skuid !== null && skuid !== void 0 ? skuid : mastersku) !== null && ref5 !== void 0 ? ref5 : "";
    const productId = "k" === ((ref3 = skuProductId[0]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) ? "".concat(skuProductId) : "K-".concat(skuProductId);
    const productInfo = {
        description: decs.toLowerCase(),
        frequency: "n/a",
        globalPromotionPrice: parentglobalPromotionPrice ? parentglobalPromotionPrice : discountedPrice > 0 ? Number((ref4 = baseprice - 0) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2)) : 0,
        globalOffer: "n/a",
        globalDiscount: discountedPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: unitPrice || baseprice,
        productCategory: productCategory.toLowerCase(),
        productColor: productColor.toLowerCase(),
        productCoupondiscount,
        productCouponCode,
        productID: productId,
        productName: Name.toLowerCase() || decs.toLowerCase() || productCategory.toLowerCase() || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: productRoomType ? productRoomType.toLowerCase() : "service",
        productSalePrice: productPrice || unitPrice || baseprice,
        productSaleable: true,
        productStatus: availableQuantity ? "in stock" : "out of stock",
        productSuperSku: false,
        productTileName: Name.toLowerCase() || "n/a",
        quantity: isPdp ? 1 : qty,
        defaultImageName: productParentImage || productImage[0],
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productCategory.toLowerCase(),
        productBrand: brandName.toLowerCase(),
        itemType: itemType ? itemType.toLowerCase() : "service",
        category: productCategory.toLowerCase()
    };
    if (index > -1 && childindex > -1) {
        productInfo.productRecommendationType = "".concat(isParent ? "parent" : "child", "|").concat(index + 1, "(").concat(productinfo.foundIndex ? productinfo.foundIndex + 1 : childindex + 1, ")");
    }
    return productInfo;
};
const addAnalyticsForADDtoCart = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, servicechecked = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", servicedata = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, persona = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "GST", serviceQTY = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, subTotal = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = "cart";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview: cart update: ".concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_TO_CART */ .G2),
        eventMsg: "n/a",
        eventName: "cart preview: cart update: ".concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_TO_CART */ .G2),
        eventStatus: "n/a",
        eventType: "naviagtion",
        internalLinkName: "add to cart",
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(_components_Shared_UpsellInstallServices_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .ADD_TO_CART */ .G2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":preview"),
        upsellCartValue: subTotal
    };
    const arr = productinfo.map((item)=>{
        const { childindex =-1 , index =-1 , totalQTY =1  } = item;
        return getrequiredProductInfo(item, childindex, index, persona, totalQTY);
    });
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", arr);
};
const addAnalyticsForIncludeforRequiredItem = function() {
    let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, included = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", recommendationTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", installServiceData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, index = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, childindex = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : -1, persona = arguments.length > 6 ? arguments[6] : void 0, isParent = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false, qty = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 1;
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID) === "home" ? "homepage" : page.category.subCategoryID;
    const isPdp = page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType;
    const parentIndex = isPdp ? 0 : index;
    const includetitle = included === null || included === void 0 ? void 0 : included.toLowerCase();
    const recommendation = recommendationTitle === null || recommendationTitle === void 0 ? void 0 : recommendationTitle.toLowerCase();
    const check = checked ? "select" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(isPdp, ":upsell product:").concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventMsg: "n/a",
        eventName: "".concat(isPdp, ":upsell product:").concat(recommendation, ": ").concat(includetitle, " ").concat(check),
        eventStatus: "n/a",
        eventType: "teaser",
        internalLinkName: "".concat(includetitle, ": ").concat(check),
        internalLinkPosition: "".concat(isPdp ? isPdp : "".concat(pageload, ":"), ":upsell"),
        internalLinkType: "".concat(isPdp ? isPdp : "".concat(pageload, ":"), ":").concat(includetitle),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(isPdp ? isPdp : "".concat(pageload, ":"), ":").concat(recommendation)
    };
    const serviceinfo = getrequiredProductInfo(installServiceData, childindex, parentIndex, persona, qty, isParent);
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, serviceinfo);
};
const addAnalyticsForArrows = function() {
    let label = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", upsellData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], index = arguments.length > 2 ? arguments[2] : void 0, persona = arguments.length > 3 ? arguments[3] : void 0, serviceAvailableTitleUpSell = arguments.length > 4 ? arguments[4] : void 0, recommendationTitle = arguments.length > 5 ? arguments[5] : void 0;
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const type = label == "Next" ? "right" : "left";
    const title = (upsellData === null || upsellData === void 0 ? void 0 : (ref = upsellData.requiredItems) === null || ref === void 0 ? void 0 : ref.length) ? recommendationTitle.toLowerCase() : serviceAvailableTitleUpSell.toLowerCase();
    const productInfoforCart = [];
    const productInfoforRequiredItems = [];
    const firstVisibleItem = upsellData ? upsellData : {};
    const { cartProductData ={} , requiredItems =[] , installServiceData ={}  } = firstVisibleItem;
    let installServiceInfo = "";
    if (!_isEmpty(installServiceData)) {
        installServiceInfo = {
            ["ProductDescriptionProductShort_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.narrativeDescription,
            ["Product_Category"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productCategory,
            image: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.productImageUrl,
            unitPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.price,
            customerFacingSKU: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
            productTileName: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.name,
            ["CustomerFacingBrand_s"]: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerBrand,
            availableQuantity: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.quantity,
            sku_s: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.customerFacingSKU,
            productParentImage: "".concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.swatchUrl).concat(installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.images, "?$SellModalDesktop$"),
            parentglobalPromotionPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.discountedPrice,
            productPrice: installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.discountedPrice
        };
    }
    const requiredDataWithInstallServiceInfo = [
        ...installServiceInfo ? [
            installServiceInfo
        ] : [],
        ...requiredItems
    ];
    var ref1;
    const cartProductInfo = (ref1 = getProductInfoForAnalytics(cartProductData, index, requiredDataWithInstallServiceInfo.length)) !== null && ref1 !== void 0 ? ref1 : {};
    productInfoforCart.push(cartProductInfo);
    var ref2;
    const requiredProductInfo = requiredDataWithInstallServiceInfo.map((item, childindex)=>(ref2 = getrequiredProductInfo(item, childindex, index, persona)) !== null && ref2 !== void 0 ? ref2 : []);
    productInfoforRequiredItems.push(requiredProductInfo);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "upsell products: ".concat(title, ": ").concat(type, " arrow"),
        eventMsg: "n/a",
        eventName: "".concat(pageload, ":").concat(title, ": ").concat(type, " arrow"),
        eventStatus: "n/a",
        eventType: "carousel",
        internalLinkName: "".concat(type, " arrow"),
        internalLinkPosition: "".concat(pageload, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(title),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, ":").concat(title)
    };
    const productInfoItems = productInfoforCart.concat(productInfoforRequiredItems.flat(2));
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, productInfoItems);
};
const getRecommendedProductInfo = (item)=>{
    const colorDetails = item["Color.SKU.Details_ss"];
    const skuDetails = item["productImages.labelWithUrl_ss"];
    const color = colorDetails.filter((ele)=>{
        return ele.split("|")[2] === item.sku_s;
    })[0].split("|")[0];
    const imageDetails = skuDetails.filter((ele)=>{
        return ele.split("|")[0] === item.sku_s;
    })[0].split("|")[5];
    const productInfo = {
        productID: item.sku_s,
        productName: item.ProductBrandName_s,
        productCategory: item.Product_Category,
        productColor: color,
        productBasePrice: item["priceList.GST.price_d"],
        productSalePrice: item["priceList.GST.finalPrice_d"],
        quantity: item.quantity,
        defaultImageName: imageDetails,
        productSource: "cart:recommendations"
    };
    return productInfo;
};
const addAnalyticsForNavigateToCart = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "recommended additions modal",
        internalLinkZoneName: "cart recommendation",
        internalLinkURL: "n/a",
        internalLinkName: "view cart",
        eventName: "cart recommendation:view cart",
        internalLinkType: "button",
        eventType: "cta",
        eventAction: "cart recommendation:view cart"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    localStorage.setItem("redirect", "pdp:cartRecommendationModal:viewCart");
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", page);
};
const addAnalyticsForClosingRecommendedModal = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "recommended additions modal",
        internalLinkZoneName: "cart recommendation",
        internalLinkURL: "n/a",
        internalLinkName: "close modal",
        eventName: "cart recommendation:close",
        internalLinkType: "button",
        eventType: "cta",
        eventAction: "cart recommendation:close"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const addAnalyticsForAddingRecommendedToCart = (productinfo)=>{
    const eventInfo = {
        eventAction: "update:recommended additions:cart",
        eventName: "update:recommended additions:cart",
        eventType: "action",
        internalLinkName: "update cart",
        internalLinkPosition: "recommended additions modal",
        internalLinkType: "modal:update cart",
        internalLinkZoneName: "recommended additions",
        clickInternalLinks: "true"
    };
    const arr = productinfo.map((item)=>{
        return getRecommendedProductInfo(item);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    localStorage.setItem("redirect", "pdp:cartRecommendationModal:updateCart");
    if (arr.length > 0) page["productArray"] = arr;
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", page);
};



/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ss": function() { return /* binding */ getProductBySkus; },
/* harmony export */   "fh": function() { return /* binding */ getProductDataFromSkuIds; },
/* harmony export */   "o": function() { return /* binding */ getProductInventory; }
/* harmony export */ });
/* unused harmony exports getListOfRequiredSkus, getZipCodes */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51666);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);





const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "sku_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "productImages.labelWithUrl_ss",
        "CustomerFacingSKU_s",
        "CrossSellRecommendationSKUList_ss"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", skus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], brandName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "kohler";
    var ref, ref1;
    const fl = getListOfParamsToFetch(persona);
    const fq = skus.map((item)=>'sku_s:("'.concat(item, '")'));
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref2;
    const language = (ref2 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref2 !== void 0 ? ref2 : "en";
    var ref3;
    const brand = (ref3 = config === null || config === void 0 ? void 0 : (ref1 = config.general) === null || ref1 === void 0 ? void 0 : ref1.siteName) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("/search/plp", {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq.join(" "),
                'language_s:("'.concat(language, '")')
            ],
            collections: brand.toLowerCase(),
            profilename: "profile_".concat(brand.toLowerCase(), "_General"),
            rows: (ref4 = skus === null || skus === void 0 ? void 0 : skus.length) !== null && ref4 !== void 0 ? ref4 : 10,
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__/* .getSessionIdObjWithEpoc */ .o)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_4___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const getListOfRequiredSkus = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sku = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    try {
        var ref;
        const fl = getListOfParamsToFetch(persona);
        const config = await getConfig();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const fq = 'sku_s:("'.concat(sku, '")');
        return apim.post("search/pdp/".concat(slug), {
            fl,
            q: "*:*",
            fq: "".concat(fq, ' AND language_s:("').concat(language, '")'),
            collections: "kohler-india",
            profilename: "profile_kohler-india_General",
            sessionId: getSessionIdObjWithEpoc()
        });
    } catch (err) {
        return {};
    }
};
const getProductInventory = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getStockEndPoint, "/?sku=").concat(skus));
};
const getZipCodes = (jsonFileUrl)=>aemAxiosInstance.get(jsonFileUrl);
const getProductBySkus = async function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], fl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref, ref1;
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, "?fl=").concat(fl, "&q=*:*&rows=10&collections=kohler-india&fq=sku_s:(").concat(query, ")&profilename=profile_kohler-india_Search"));
    if (res && res.data) return res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs;
    return [];
};



/***/ }),

/***/ 5600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        search: t("kf.pdp.label.searchBtn"),
        signIn: t("kf.loggedin.button.signIn"),
        or: t("kf.global.label.or"),
        createCartAccount: t("kf.cart.label.createCartAccount"),
        saveYourCart: t("kf.cart.label.saveYourCart"),
        needHelpOrder: t("kf.cart.label.needHelpOrder"),
        callSupport: t("kf.cart.label.callSupport"),
        serviceAvailableTitleUpSell: t("kf.upSellRecommended.serviceAvailableTitleUpSell"),
        recommendationTitle: t("kf.upSellRecommended.recommendationTitle"),
        includeTitle: t("kf.upSellRecommended.includeTitle"),
        outOfStockTitle: t("kf.upSellRecommended.outOfStockTitle"),
        selectedTitle: t("kf.upSellRecommended.selectedTitle"),
        arrowLabel: t("kf.upSellRecommended.arrowLabel"),
        recommendedAdditions: t("kf.upSellRecommended.recommendedAdditions")
    };
};


/***/ }),

/***/ 34846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(93468);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./src/components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) props.onChange(e);
    };
    var _tabIndex, _role, _checkBoxAria;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            htmlFor: props.id,
            "aria-checked": props.checked,
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "Checkbox"
                        })
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};


/***/ }),

/***/ 45138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25219);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ToolTip = (props)=>{
    const [{ children =null , ...attr }, setAttribute] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: props.id,
        role: "tooltip",
        tabIndex: props.setFocus ? 0 : -1,
        "aria-label": props.ariaLabel,
        children: props.message
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAttribute({
            ...attr,
            children: props.message
        });
    }, [
        props.message
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (props.setFocus) (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        props.setFocus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltipWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tooltip__container",
            role: "alert",
            "aria-live": "polite",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "--label",
                            children: "".concat(props.label, ":")
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ...attr,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 27522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ addToCartItem; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/**
 * It add to cart Utility for pay load
 * @returns the addToCartItem
 */ 
const addToCartItem = async (items)=>{
    var ref;
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actionPayload = actionProduct(items, salesChannels, userZipCode);
    return actionPayload;
};
/**
 *  payload to add to cart.
 * @param {items} items The first param.
 * @param {salesChannels} salesChannels The second param.
 * @param {userZipCode} userZipCode The third param.
 * @return {object} the pay load for add to cart
 */ const actionProduct = (items, salesChannels, userZipCode)=>{
    const actions = [];
    let actionData;
    items.forEach((product)=>{
        var ref;
        if (product.backorder) fields.isBackOrderable = true;
        var _quantity;
        actions.push({
            action: product.isBundle ? "addbundle" : "addLineItem",
            sku: product.sku,
            quantity: (_quantity = product.quantity) !== null && _quantity !== void 0 ? _quantity : 0,
            custom: (product === null || product === void 0 ? void 0 : product.isInstallService) ? {
                type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type"
                },
                fields: {
                    associatedService: product === null || product === void 0 ? void 0 : product.installServiceName,
                    associatedServiceQty: (product === null || product === void 0 ? void 0 : product.installServiceQty) || 1,
                    warehouses: product === null || product === void 0 ? void 0 : product.warehouses
                }
            } : !(product === null || product === void 0 ? void 0 : (ref = product.sku) === null || ref === void 0 ? void 0 : ref.split("_").includes("INST")) ? {
                type: {
                    key: "cartLineItemAdditionalInfo",
                    typeId: "type"
                },
                fields: {
                    warehouses: product === null || product === void 0 ? void 0 : product.warehouses
                }
            } : ""
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
        // console.log(actions)
        actionData = [
            ...actions
        ];
    });
    return actionData;
};


/***/ }),

/***/ 77145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"requireditem":"RequiredProductItem_requireditem__DCL8M"};

/***/ }),

/***/ 48320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upsellmodal":"UpsellInstallServices_upsellmodal__oKO8K"};

/***/ }),

/***/ 93468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__KI6CF","inlineCheckbox":"Checkbox_inlineCheckbox__4YHUm"};

/***/ }),

/***/ 25219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__JMsKi"};

/***/ })

}]);